import React from 'react';
import { motion } from 'framer-motion';

export default function Privacy() {
  return (
    <div className="bg-white min-h-screen py-20 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-3xl mx-auto"
      >
        <div className="mb-10">
          <span className="text-xs font-bold uppercase tracking-widest text-blue-600">Legal</span>
          <h1 className="text-4xl font-extrabold text-slate-900 mt-2 mb-4">Privacy Policy</h1>
          <div className="h-1 w-16 bg-blue-600 rounded-full" />
        </div>
        <div className="prose prose-slate max-w-none text-slate-600 leading-relaxed space-y-6">
          <p className="text-lg">
            GetSwitchFree is committed to your privacy. We do not sell your personal data to third
            parties. We collect basic information (IP address, device type) to improve user
            experience. When you use our partner widgets (e.g., for loans or carrier plans), you
            are interacting with third-party providers who have their own privacy policies. We use
            industry-standard SSL encryption to protect your browsing session.
          </p>
          <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6">
            <p className="text-sm text-blue-800 font-medium">
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}